import { useState, createContext, useEffect } from 'react';

const ContextTela = createContext();

export function ContextTelaProvider({ children }) {
  const [tela, setTela] = useState('');
  const [loadding, setLoading] = useState([]);
  const [iframeLoad, setIframeLoad] = useState(true);
  const contextValue = {
    loadding,
    setLoading,
    tela,
    desktop: tela == 'desktop',
    mobile: tela == 'mobile',
    telaOposta: tela == 'desktop' ? 'mobile' : 'desktop',
    setTela,
    iframeLoad,
    setIframeLoad,
  };

  return <ContextTela.Provider value={contextValue}>{children}</ContextTela.Provider>;
}

export default ContextTela;
